import gql from 'graphql-tag';

export const mutationResetDokkioUserPassword = gql`
  mutation resetDokkioUserPassword (
    $accountID: DokkioID!
    $dokkioUserID: DokkioID!
    $password: String!
    $verificationHash: String!
  ) {
    resetDokkioUserPassword (
      accountID: $accountID
      dokkioUserID: $dokkioUserID
      password: $password
      verificationHash: $verificationHash
    )
  }
`;
export default mutationResetDokkioUserPassword;
